/** @type {"onSIChange"} */
export const ON_SI_CHANGE = "onSIChange";
/** @type {"onSIBeforeChange"} */
export const ON_SI_BEFORE_CHANGE = "onSIBeforeChange";
/** @type {"onSIInput"} */
export const ON_SI_INPUT = "onSIInput";

export const ALL_HANDLERS = [ON_SI_CHANGE, ON_SI_BEFORE_CHANGE, ON_SI_INPUT];
export const PREVIEWABLE_HANDLERS = [ON_SI_BEFORE_CHANGE, ON_SI_INPUT];